import './innersvg-polyfill'
import Vue from 'vue'
import VueSVGIcon from 'vue-svgicon'
import vSelect from 'vue-select'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import VueAffix from 'vue-affix'
import VTooltip from 'v-tooltip'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import VueGeolocation from 'vue-browser-geolocation';
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import SocialSharing from 'vue-social-sharing'
import ErrorList from "../components/ErrorList";
import FsLightbox from "fslightbox-vue";
import LightboxBase from "../components/LightboxBase";
import LightboxGallery from "../components/LightboxGallery";
import Accordion from "../components/Accordion";
import Counter from "../components/Counter";

Vue.use(VueAwesomeSwiper)
Vue.use(VueSVGIcon)
Vue.use(VueAffix)
Vue.use(VTooltip)
Vue.use(VueGeolocation);
Vue.use(ClipLoader);
Vue.use(SocialSharing)
Vue.component('vue-google-autocomplete', VueGoogleAutocomplete)
Vue.component('v-select', vSelect)
Vue.component('clip-loader', ClipLoader)
Vue.component('lightbox-base', LightboxBase)
Vue.component('lightbox-gallery', LightboxGallery)
Vue.component('error-list', ErrorList)
Vue.component('fs-lightbox', FsLightbox)
Vue.component('accordion', Accordion);
Vue.component('counter', Counter)
Vue.filter('date_format', (d) => {
    return (new Date(d)).toLocaleDateString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' });
});

Vue.config.productionTip = false

window.Vue = Vue

import * as Icons from '../img/svg';

import axios from 'axios'
window.axios = axios


import fontawesome from '@fortawesome/fontawesome';

import faArrowLeft from '@fortawesome/fontawesome-free-solid/faArrowLeft';
import faArrowRight from '@fortawesome/fontawesome-free-solid/faArrowRight';
import faArrowUp from '@fortawesome/fontawesome-free-solid/faArrowUp';
import faChevronRight from '@fortawesome/fontawesome-free-solid/faChevronRight';
import faStar from '@fortawesome/fontawesome-free-solid/faStar';
import faStarHalf from '@fortawesome/fontawesome-free-solid/faStarHalf';
import faMapMarkerAlt from '@fortawesome/fontawesome-free-solid/faMapMarkerAlt';
import faCalendarAlt from '@fortawesome/fontawesome-free-solid/faCalendarAlt';
import faEuroSign from '@fortawesome/fontawesome-free-solid/faEuroSign';
import faSuperscript from '@fortawesome/fontawesome-free-solid/faSuperscript';
import faComment from '@fortawesome/fontawesome-free-solid/faComment';
import faGraduationCap from '@fortawesome/fontawesome-free-solid/faGraduationCap';
import faExclamation from '@fortawesome/fontawesome-free-solid/faExclamation';
import faDna from '@fortawesome/fontawesome-free-solid/faDna';
import faAngleLeft from '@fortawesome/fontawesome-free-solid/faAngleLeft';
import faStore from '@fortawesome/fontawesome-free-solid/faStore';
import faBook from '@fortawesome/fontawesome-free-solid/faBook';
import faCameraRetro from '@fortawesome/fontawesome-free-solid/faCameraRetro';
import faInfoCircle from '@fortawesome/fontawesome-free-solid/faInfoCircle';
import faHome from '@fortawesome/fontawesome-free-solid/faHome';
import faAngleRight from '@fortawesome/fontawesome-free-solid/faAngleRight';
import faSpinner from '@fortawesome/fontawesome-free-solid/faSpinner';
import faCheck from '@fortawesome/fontawesome-free-solid/faCheck';
import faCheckSquare from '@fortawesome/fontawesome-free-solid/faCheckSquare';

import faWhatsapp from '@fortawesome/fontawesome-free-brands/faWhatsapp';
import faFacebookF from '@fortawesome/fontawesome-free-brands/faFacebookF';
import faYoutube from '@fortawesome/fontawesome-free-brands/faYoutube';
import faInstagram from '@fortawesome/fontawesome-free-brands/faInstagram';

fontawesome.library.add(faArrowRight,faArrowUp,faArrowLeft,faChevronRight,faStarHalf,faInfoCircle, faStar, faMapMarkerAlt, faCalendarAlt, faEuroSign, faSuperscript, faComment, faGraduationCap, faExclamation, faDna, faAngleLeft, faHome, faFacebookF, faYoutube, faInstagram, faStore, faBook, faCameraRetro, faAngleRight, faSpinner, faCheck, faCheckSquare, faWhatsapp);
fontawesome.dom.i2svg();
